import {
  CirclesThree,
  Fire,
  Hexagon as HexagonIcon,
  MapPin,
  GridNine,
  MapTrifold
} from '@phosphor-icons/react'
import { useAggregateOptions } from '~map-preview/states/boundaries'
import { useCategoryOptions } from '~map-preview/states/map'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import {
  Category as CategoryType,
  Heatmap as HeatmapType,
  Hexagon as HexagonType,
  Marker as MarkerType,
  Cluster as ClusterType
} from '~map-preview/types/__generated/gql/graphql'

export const visualizations = [
  {
    parent: 'point',
    id: 'marker',
    type: 'marker',
    label: 'Markers',
    Icon: MapPin,
    visible: true
  } as MarkerType,
  {
    parent: 'point',
    id: 'category',
    type: 'category',
    label: 'Categories',
    property: '',
    Icon: CirclesThree,
    visible: true
  } as CategoryType,
  {
    parent: 'point',
    id: 'heatmap',
    type: 'heatmap',
    label: 'Heatmap',
    Icon: Fire,
    visible: true
  } as HeatmapType
]

export const useGetVisualizationOptions = () => {
  const { visualization } = useMapToolbarStore()
  const options = useAggregateOptions()
  const categoryOptions = useCategoryOptions()

  let visualizationOptions = [...visualizations] // Clone array to avoid mutations

  if (options.length > 0) {
    visualizationOptions = visualizationOptions.concat(
      options.map((item: { value: string; label: string }) => ({
        parent: 'aggregate',
        id: item.value,
        type: 'aggregate',
        property: item.value,
        aggregate: 'count',
        display: '2D',
        label: item.label,
        Icon: MapTrifold
      }))
    )
  }

  // Add hexagon only if it doesn't already exist
  if (!visualizationOptions.some((item) => item.id === 'hexagon')) {
    visualizationOptions.push({
      type: 'hexagon',
      display: '2D',
      parent: 'aggregate',
      property: '',
      id: 'hexagon',
      label: 'Hexagon',
      size: 'medium',
      Icon: HexagonIcon,
      visible: true
    } as HexagonType)
  }

  // Add data-views only if it doesn't already exist
  if (!visualizationOptions.some((item) => item.id === 'data-views')) {
    visualizationOptions.push({
      type: 'data-views',
      parent: 'data-views',
      id: 'data-views',
      label: 'Data table',
      size: 'large',
      Icon: GridNine,
      visible: true
    } as any)
  }

  // Hide category visualization if there are no category options
  if (categoryOptions.length === 0) {
    visualizationOptions = visualizationOptions.map((item) =>
      item.type === 'category' ? { ...item, visible: false } : item
    )
  }

  return {
    options: visualizationOptions,
    selected:
      (visualization && Object.values(visualization)[0]) || visualizations[0]
  }
}
